import { FC } from "react"
import { MainLayout } from "./MainLayout"

export const LockersPage: FC = () => {
  return <MainLayout>lockers page</MainLayout>
}
